import React from 'react';
import { Tooltip as TooltipBase, TooltipProps } from '@x5-react-uikit/core';

interface Props extends TooltipProps {
  isVisible?: boolean;
}

const TooltipX5 = ({
  children,
  content = '',
  isVisible = true,
  placement = 'top',
  ...rest
}: Props) => {
  if (!isVisible) return <>{children}</>;
  return (
    <TooltipBase content={content} placement={placement} {...rest}>
      {children}
    </TooltipBase>
  );
};

export default TooltipX5;
